/* ==========================================================================
   OLIVO Natural Soap, site behaviour
   Vanilla JS, no dependencies. Cart is in-memory by design: an order is a
   short WhatsApp conversation, not an account.

   Stock, prices and names come live from Shopify (the admin is the source
   of truth); the list below is only the offline fallback for local preview.
   ========================================================================== */
(function () {
  "use strict";

  var WA_NUMBER = "971528002290"; /* WhatsApp and phone, from the business card */
  var IG_DM = "https://ig.me/m/olivo.natural.soap"; /* opens our Instagram chat */
  var MIN_ORDER = 60; /* AED, minimum basket total for checkout */

  /* ------------------------------------------------------------------ */
  /* Catalogue registry (names and prices are canonical, do not invent)  */
  /* price:null means "ask on WhatsApp" (unconfirmed or special order)   */
  /* ------------------------------------------------------------------ */
  var PRODUCTS = {
    "saffron":            { en: "Saffron with Olive Oil",                ar: "الزعفرانة مع زيت الزيتون النقي",      price: 35,   collection: "premium",  available: true },
    "frankincense":       { en: "Frankincense with Olive Oil",           ar: "لبان ذكر",                            price: 35,   collection: "premium",  available: true },
    "honey-black-seed":   { en: "Honey & Black Seed with Olive Oil",     ar: "عسل صافي مع حبة البركة",              price: 35,   collection: "premium",  available: true },
    "coffee":             { en: "Coffee with Olive Oil",                 ar: "القهوة مع زيت الزيتون النقي",         price: 35,   collection: "premium",  available: true },
    "massage-loofah":     { en: "Massage Soap with Natural Loofah",      ar: "مساج مع ليفة",                        price: 40,   collection: "massage",  available: true },
    "coffee-massage":     { en: "Coffee Massage Soap with Natural Loofah", ar: "مساج القهوة مع ليفة",              price: 40,   collection: "massage",  available: true },
    "pure-olive":         { en: "Pure Olive Oil Soap",                   ar: "زيتونا",                              price: 30,   collection: "classic",  available: true },
    "aloe-black-seed":    { en: "Aloe Vera & Black Seed with Olive Oil", ar: "الصبارة مع حبة البركة",               price: 30,   collection: "classic",  available: true },
    "mint":               { en: "Mint with Olive Oil",                   ar: "نعناعة",                              price: 30,   collection: "classic",  available: true },
    "musk":               { en: "Musk with Olive Oil",                   ar: "مسك",                                 price: 30,   collection: "classic",  available: true },
    "vanilla-coconut":    { en: "Vanilla & Coconut with Olive Oil",      ar: "جوز الهند مع الفانيلا",               price: 30,   collection: "classic",  available: true },
    "rosemary":           { en: "Rosemary with Olive Oil",               ar: "إكليل الجبل",                         price: 30,   collection: "classic",  available: true },
    "rose":               { en: "Rose with Olive Oil",                   ar: "وردتنا",                              price: 30,   collection: "classic",  available: true },
    "rose-oudh":          { en: "Rose & Oudh with Olive Oil",            ar: "ورد مع عود",                          price: 30,   collection: "classic",  available: true },
    "grapes":             { en: "Grapes with Olive Oil",                 ar: "عنب مع زيت الزيتون",                  price: 30,   collection: "classic",  available: true },
    "strawberry-lemon":   { en: "Strawberry & Lemon with Black Seeds",   ar: "فراولة مع ليمون مع حبة البركة",       price: 30,   collection: "classic",  available: true },
    /* photographed range, placement and price to confirm with the owner */
    "oat-coconut":        { en: "Oat with Coconut",                      ar: "الشوفان",                             price: 30,   collection: "range",    available: true },
    "lemon-honey":        { en: "Lemon Honey",                           ar: "ليمون مع عسل",                        price: 30,   collection: "range",    available: true },
    "grapes-coconut":     { en: "Grapes with Coconut and Olive Oil",     ar: "عنب مع جوز الهند",                    price: 30,   collection: "range",    available: true },
    "luxury-in-every-bar":{ en: "Luxury in Every Bar",                   ar: "فخامة في كل صابونة",                  price: 200,  collection: "gift-box", available: true },
    "hello-summer":       { en: "Hello Summer!",                         ar: "أهلاً بالصيف!",                        price: 170,  collection: "gift-box", available: true },
    "hello-summer-END": null
  };
  delete PRODUCTS["hello-summer-END"];

  /* Shopify variant ids: lets "Pay online" hand the basket to the real
     Shopify checkout (Ziina, cards) via a cart permalink */
  var VIDS = {
    "saffron": "51961794003232", "frankincense": "51961794036000",
    "honey-black-seed": "51961794068768", "coffee": "51961794101536",
    "massage-loofah": "51961794167072", "coffee-massage": "51963774861600", "pure-olive": "51961794199840",
    "neem": "51971129606432",
    "aloe-black-seed": "51961794232608", "mint": "51961796198688",
    "musk": "51961796231456", "vanilla-coconut": "51961796264224",
    "rosemary": "51961796296992", "rose": "51961796329760",
    "rose-oudh": "51961796362528", "grapes": "51961796395296",
    "strawberry-lemon": "51961796591904", "oat-coconut": "51961796624672",
    "lemon-honey": "51961796690208", "grapes-coconut": "51961796722976",
    "luxury-in-every-bar": "51961932415264", "hello-summer": "51961932448032"
  };
  for (var vk in VIDS) if (PRODUCTS[vk]) PRODUCTS[vk].vid = VIDS[vk];

  /* ------------------------------------------------------------------ */
  /* Live catalogue from Shopify.                                        */
  /* On the Shopify theme, the layout injects window.SHOPIFY_PRODUCTS    */
  /* before this file runs, so Shopify admin is the source of truth:     */
  /* products, prices and stock come from there. On the static site,     */
  /* shopify-live.js delivers the same list asynchronously through       */
  /* window.OLIVO.applyShopify once it is configured.                    */
  /* ------------------------------------------------------------------ */
  function applyRegistry(list) {
    (list || []).forEach(function (p) {
      if (!p || !p.id) return;
      PRODUCTS[p.id] = {
        en: p.en, ar: p.ar || p.en,
        price: (p.price === null || p.price === undefined || p.price === "") ? null : Number(p.price),
        collection: p.collection || "classic",
        available: p.available !== false,
        img: p.img || null, url: p.url || null, vid: p.vid || VIDS[p.id] || null
      };
    });
  }
  if (window.SHOPIFY_PRODUCTS) applyRegistry(window.SHOPIFY_PRODUCTS);

  /* Delivery fees: baked defaults, overridden live from Shopify shop
     metafields (custom.delivery_auh / custom.delivery_uae) */
  var FEES = { auh: 30, uae: 50 };
  if (window.SHOPIFY_DELIVERY) {
    if (window.SHOPIFY_DELIVERY.auh) FEES.auh = window.SHOPIFY_DELIVERY.auh;
    if (window.SHOPIFY_DELIVERY.uae) FEES.uae = window.SHOPIFY_DELIVERY.uae;
  }
  function applyFees() {
    $all("[data-fee]").forEach(function (el) {
      var v = FEES[el.getAttribute("data-fee")];
      if (v) el.textContent = v;
    });
  }

  /* ------------------------------------------------------------------ */
  /* UI strings                                                          */
  /* ------------------------------------------------------------------ */
  var LANG = document.documentElement.lang === "ar" ? "ar" : "en";
  var T = {
    en: {
      aed: "AED",
      added: "Added to your basket",
      soldOut: "Sold out",
      requestSoap: "Request this soap",
      addToCart: "Add to basket",
      askWhatsApp: "Ask on WhatsApp",
      cartEmpty: "Your basket is empty for now. The soaps are waiting.",
      total: "Total",
      copyOk: "Order copied. Paste it anywhere.",
      copyFail: "Could not copy automatically. Please use the WhatsApp button.",
      needCart: "Your basket is empty.",
      needFields: "Please add your name and phone number.",
      waRequest: function (p) {
        return "Hello OLIVO, I would like to ask about " + p.en + " (" + p.ar + "). When will it be back in stock?";
      },
      orderIntro: "Hello OLIVO, I would like to place an order:",
      orderPayment: "Payment: Cash on Delivery",
      orderPaymentBank: "Payment: Bank transfer (please send me the details)",
      onlineMissing: "Online payment is not available for an item in your basket. Please use WhatsApp instead.",
      minOrder: "The minimum order is 60 AED. Add one more soap and you are there.",
      orderPaymentOnline: "Payment: online (Ziina or card), paid at checkout",
      confirmWA: "Confirm on WhatsApp",
      confirmOnline: "Continue to secure checkout",
      igCopied: "Order copied. Paste it into the Instagram chat.",
      orderName: "Name", orderPhone: "Phone", orderEmirate: "Emirate",
      orderArea: "Area", orderNote: "Note",
      itemLine: function (q, p, sum) { return q + " x " + p.en + " (" + p.ar + ") = " + sum + " AED"; },
      giftIntro: "Hello OLIVO, I would like a quote for a gift order:",
      giftOccasion: "Occasion", giftQty: "Quantity", giftDate: "Needed by", giftBudget: "Budget",
      contactIntro: "Hello OLIVO, my name is ", contactMsgIs: ". My message: ",
      formSim: "This form is a local preview. Opening WhatsApp instead.",
      priceOnRequest: "Price on request"
    },
    ar: {
      aed: "درهم",
      added: "أُضيف إلى السلة",
      soldOut: "نفدت الكمية",
      requestSoap: "اسألوا عن هذه الصابونة",
      addToCart: "أضيفوا إلى السلة",
      askWhatsApp: "اسألوا عبر واتساب",
      cartEmpty: "سلتكم فارغة حالياً، والصابون بانتظاركم.",
      total: "المجموع",
      copyOk: "تم نسخ الطلب. الصقوه في أي مكان.",
      copyFail: "تعذّر النسخ تلقائياً. استخدموا زر واتساب من فضلكم.",
      needCart: "سلتكم فارغة.",
      needFields: "يرجى كتابة الاسم ورقم الهاتف.",
      waRequest: function (p) {
        return "مرحباً أوليفو، أودّ السؤال عن " + p.ar + " (" + p.en + "). متى تتوفر مجدداً؟";
      },
      orderIntro: "مرحباً أوليفو، أودّ تقديم هذا الطلب:",
      orderPayment: "الدفع: نقداً عند الاستلام",
      orderPaymentBank: "الدفع: تحويل بنكي (أرسلوا لي التفاصيل من فضلكم)",
      onlineMissing: "الدفع الإلكتروني غير متاح لأحد الأصناف في سلتكم. استخدموا واتساب من فضلكم.",
      minOrder: "الحد الأدنى للطلب 60 درهماً. أضيفوا صابونة أخرى وتصلون إليه.",
      orderPaymentOnline: "الدفع: إلكترونياً (زينة أو بطاقة)، تم عند إتمام الطلب",
      confirmWA: "تأكيد الطلب عبر واتساب",
      confirmOnline: "المتابعة إلى الدفع الآمن",
      igCopied: "نُسخ الطلب. الصقوه في محادثة إنستغرام.",
      orderName: "الاسم", orderPhone: "الهاتف", orderEmirate: "الإمارة",
      orderArea: "المنطقة", orderNote: "ملاحظة",
      itemLine: function (q, p, sum) { return q + " × " + p.ar + " (" + p.en + ") = " + sum + " درهم"; },
      giftIntro: "مرحباً أوليفو، أودّ عرض سعر لطلب هدايا:",
      giftOccasion: "المناسبة", giftQty: "الكمية", giftDate: "التاريخ المطلوب", giftBudget: "الميزانية",
      contactIntro: "مرحباً أوليفو، اسمي ", contactMsgIs: ". رسالتي: ",
      formSim: "هذا النموذج معاينة محلية، سنفتح واتساب بدلاً منه.",
      priceOnRequest: "السعر عند الطلب"
    }
  }[LANG];

  function money(n) { return LANG === "ar" ? n + " " + T.aed : n + " " + T.aed; }
  function waLink(text) { return "https://wa.me/" + WA_NUMBER + "?text=" + encodeURIComponent(text); }
  function openWA(text) { window.open(waLink(text), "_blank", "noopener"); }
  function $(sel, root) { return (root || document).querySelector(sel); }
  function $all(sel, root) { return Array.prototype.slice.call((root || document).querySelectorAll(sel)); }

  /* toast ------------------------------------------------------------- */
  var toastEl = null, toastTimer = null;
  function toast(msg) {
    if (!toastEl) {
      toastEl = document.createElement("div");
      toastEl.className = "toast";
      toastEl.setAttribute("role", "status");
      document.body.appendChild(toastEl);
    }
    toastEl.textContent = msg;
    toastEl.classList.add("show");
    clearTimeout(toastTimer);
    toastTimer = setTimeout(function () { toastEl.classList.remove("show"); }, 2600);
  }

  /* ------------------------------------------------------------------ */
  /* Cart (in-memory)                                                    */
  /* ------------------------------------------------------------------ */
  var cart = {}; /* id -> qty */

  function cartCount() {
    var n = 0; for (var k in cart) n += cart[k];
    return n;
  }
  function cartTotal() {
    var t = 0;
    for (var k in cart) t += (PRODUCTS[k].price || 0) * cart[k];
    return t;
  }
  function addToCart(id, qty) {
    var p = PRODUCTS[id];
    if (!p || !p.available || p.price === null) return;
    cart[id] = (cart[id] || 0) + (qty || 1);
    renderCart();
    toast(T.added);
  }

  var drawer, overlay, fab, itemsEl, totalEl, countEls;

  function openCart() {
    if (!drawer) return;
    drawer.classList.add("open"); overlay.classList.add("open");
    drawer.setAttribute("aria-hidden", "false");
    drawer.inert = false;
    showView("cart");
    var c = $(".cart-close", drawer); if (c) c.focus();
  }
  function closeCart() {
    if (!drawer) return;
    drawer.classList.remove("open"); overlay.classList.remove("open");
    drawer.setAttribute("aria-hidden", "true");
    drawer.inert = true;
    if (fab) fab.focus();
  }
  function showView(name) {
    $all(".cart-view", drawer).forEach(function (v) {
      v.classList.toggle("active", v.getAttribute("data-view") === name);
    });
  }

  function renderCart() {
    if (!itemsEl) return;
    itemsEl.innerHTML = "";
    var ids = Object.keys(cart);
    if (!ids.length) {
      var e = document.createElement("p");
      e.className = "cart-empty"; e.textContent = T.cartEmpty;
      itemsEl.appendChild(e);
    }
    ids.forEach(function (id) {
      var p = PRODUCTS[id], q = cart[id];
      var li = document.createElement("div");
      li.className = "cart-item";
      var name = LANG === "ar" ? p.ar : p.en;
      var sub = LANG === "ar" ? p.en : p.ar;
      li.innerHTML =
        '<div class="ci-top"><span class="ci-name"></span><span></span></div>' +
        '<span class="ci-sub"></span>' +
        '<div class="ci-row"><span class="qty">' +
        '<button type="button" data-dec aria-label="-">&minus;</button>' +
        '<input type="number" min="1" value="' + q + '" aria-label="qty">' +
        '<button type="button" data-inc aria-label="+">+</button></span>' +
        '<strong>' + money(p.price * q) + '</strong>' +
        '<button type="button" class="ci-remove" data-remove></button></div>';
      $(".ci-name", li).textContent = name;
      $(".ci-sub", li).textContent = sub;
      $("[data-remove]", li).textContent = LANG === "ar" ? "إزالة" : "Remove";
      $("[data-inc]", li).addEventListener("click", function () { cart[id]++; renderCart(); });
      $("[data-dec]", li).addEventListener("click", function () {
        cart[id]--; if (cart[id] <= 0) delete cart[id]; renderCart();
      });
      $("input", li).addEventListener("change", function () {
        var v = parseInt(this.value, 10);
        if (!v || v < 1) { delete cart[id]; } else { cart[id] = v; }
        renderCart();
      });
      $("[data-remove]", li).addEventListener("click", function () { delete cart[id]; renderCart(); });
      itemsEl.appendChild(li);
    });
    if (totalEl) totalEl.textContent = money(cartTotal());
    var n = cartCount();
    countEls.forEach(function (el) { el.textContent = n; });
    if (fab) fab.style.display = "flex";
  }

  /* order message ------------------------------------------------------ */
  function composeOrder(form) {
    var lines = [T.orderIntro, ""];
    for (var id in cart) {
      var p = PRODUCTS[id];
      lines.push("- " + T.itemLine(cart[id], p, p.price * cart[id]));
    }
    lines.push("");
    lines.push(T.total + ": " + money(cartTotal()));
    lines.push(form.pay === "online" ? T.orderPaymentOnline : form.pay === "bank" ? T.orderPaymentBank : T.orderPayment);
    lines.push("");
    lines.push(T.orderName + ": " + form.name);
    lines.push(T.orderPhone + ": " + form.phone);
    lines.push(T.orderEmirate + ": " + form.emirate + (form.area ? " / " + T.orderArea + ": " + form.area : ""));
    if (form.note) lines.push(T.orderNote + ": " + form.note);
    return lines.join("\n");
  }

  function readCheckoutForm() {
    return {
      name: ($("#co-name") || {}).value ? $("#co-name").value.trim() : "",
      phone: ($("#co-phone") || {}).value ? $("#co-phone").value.trim() : "",
      emirate: ($("#co-emirate") || {}).value || "",
      area: ($("#co-area") || {}).value ? $("#co-area").value.trim() : "",
      note: ($("#co-note") || {}).value ? $("#co-note").value.trim() : "",
      pay: (document.querySelector('input[name="co-pay"]:checked') || {}).value || "cod"
    };
  }

  function validCheckout(f) {
    if (!Object.keys(cart).length) { toast(T.needCart); return false; }
    if (!f.name || !f.phone) { toast(T.needFields); return false; }
    return true;
  }

  function copyText(text, okMsg, failMsg) {
    function fallback() {
      var ta = document.createElement("textarea");
      ta.value = text; ta.setAttribute("readonly", "");
      ta.style.position = "fixed"; ta.style.insetBlockStart = "-100vh";
      document.body.appendChild(ta); ta.select();
      try { document.execCommand("copy"); toast(okMsg); }
      catch (e) { toast(failMsg); }
      document.body.removeChild(ta);
    }
    if (navigator.clipboard && navigator.clipboard.writeText) {
      navigator.clipboard.writeText(text).then(function () { toast(okMsg); }, fallback);
    } else { fallback(); }
  }

  /* ------------------------------------------------------------------ */
  /* Product cards: one idempotent wire + sync path, so cards rendered   */
  /* statically, by Liquid, or added later from Shopify all behave the   */
  /* same and can flip between in-stock and sold-out without a reload.   */
  /* ------------------------------------------------------------------ */
  var uiReady = false, pendingSync = null;

  function syncCardUI(card) {
    var p = PRODUCTS[card.getAttribute("data-product")];
    if (!p) return;
    var soldout = p.available === false;
    card.classList.toggle("is-soldout", soldout);
    var photo = $(".card-photo", card);
    var badge = photo ? $(".badge-soldout", photo) : null;
    if (soldout && photo && !badge) {
      badge = document.createElement("span");
      badge.className = "badge-soldout"; badge.textContent = T.soldOut;
      photo.appendChild(badge);
    } else if (!soldout && badge) {
      badge.parentNode.removeChild(badge);
    }
    $all("[data-add]", card).forEach(function (btn) {
      btn.textContent = soldout ? T.requestSoap : T.addToCart;
    });
    var priceEl = $(".card-price", card);
    if (priceEl && p.price) priceEl.textContent = p.price + " " + T.aed;
    var nameEl = $(".card-name a", card) || $(".card-name", card) || $(".bb-name", card);
    if (nameEl) nameEl.textContent = LANG === "ar" ? p.ar : p.en;
    var altEl = $(".card-alt", card);
    if (altEl) altEl.textContent = (LANG === "ar" ? p.en : p.ar) || "";
  }

  function wireCard(card) {
    var id = card.getAttribute("data-product");
    if (!PRODUCTS[id]) return;
    if (card.getAttribute("data-wired")) { syncCardUI(card); return; }
    card.setAttribute("data-wired", "1");
    $all("[data-add]", card).forEach(function (btn) {
      btn.addEventListener("click", function () {
        var p = PRODUCTS[id];
        if (p.available === false || p.price === null || p.price === undefined) {
          openWA(T.waRequest(p)); return;
        }
        var qtyInput = $("[data-qty]", card);
        addToCart(id, qtyInput ? Math.max(1, parseInt(qtyInput.value, 10) || 1) : 1);
      });
    });
    var ask = $("[data-ask]", card);
    if (ask) ask.addEventListener("click", function () { openWA(T.waRequest(PRODUCTS[id])); });
    syncCardUI(card);
  }

  function resortGrid() {
    var grid = $("[data-shop-grid]");
    if (!grid) return;
    $all("[data-product]", grid)
      .filter(function (c) { return c.classList.contains("is-soldout"); })
      .forEach(function (c) { grid.appendChild(c); });
  }

  function shopifyImg(u, w) { return u + (u.indexOf("?") >= 0 ? "&" : "?") + "width=" + w; }

  function buildCardEl(id) {
    var p = PRODUCTS[id];
    var art = document.createElement("article");
    art.className = "card";
    art.setAttribute("data-product", id);
    art.setAttribute("data-collection", p.collection || "classic");
    var photo = p.img
      ? '<img src="' + shopifyImg(p.img, 800) + '" srcset="' +
        [480, 800, 1200, 1600].map(function (w) { return shopifyImg(p.img, w) + " " + w + "w"; }).join(", ") +
        '" sizes="(min-width:980px) 23vw, (min-width:560px) 45vw, 92vw" width="800" height="1000" alt="" loading="lazy" decoding="async">'
      : '<div style="aspect-ratio:4/5;background:var(--cream-deep)"></div>';
    var priceLine = '<p class="card-price">' + (p.price ? p.price + " " + T.aed : T.priceOnRequest) + "</p>";
    var action = p.price
      ? '<button type="button" class="btn btn-solid btn-s" data-add>' + T.addToCart + "</button>"
      : '<button type="button" class="btn btn-outline btn-s" data-ask>' + T.askWhatsApp + "</button>";
    var more = p.url ? '<a class="btn btn-ghost btn-s" href="' + p.url + '">' + (LANG === "ar" ? "التفاصيل" : "View") + "</a>" : "";
    art.innerHTML =
      '<div class="card-photo">' + (p.url ? '<a href="' + p.url + '" tabindex="-1" aria-hidden="true">' + photo + "</a>" : photo) + "</div>" +
      '<div class="card-body"><h3 class="card-name">' + (p.url ? '<a href="' + p.url + '"></a>' : "<span></span>") + "</h3>" +
      '<p class="card-alt" ' + (LANG === "ar" ? 'lang="en" dir="ltr"' : 'lang="ar" dir="rtl"') + "></p>" +
      priceLine + '<div class="card-actions">' + action + more + "</div></div>";
    $(".card-name a", art) ? ($(".card-name a", art).textContent = LANG === "ar" ? p.ar : p.en)
      : ($(".card-name span", art).textContent = LANG === "ar" ? p.ar : p.en);
    $(".card-alt", art).textContent = (LANG === "ar" ? p.en : p.ar) || "";
    return art;
  }

  function applyShopify(list, opts) {
    applyRegistry(list);
    var run = function () {
      $all("[data-product]").forEach(wireCard);
      if (opts && opts.appendNew) {
        var grid = $("[data-shop-grid]");
        if (grid) (list || []).forEach(function (p) {
          if (!p || !p.id) return;
          if (document.querySelector('[data-product="' + p.id + '"]')) return;
          var el = buildCardEl(p.id);
          grid.appendChild(el);
          wireCard(el);
        });
      }
      /* Shopify as the complete catalogue: hide catalogue cards for products
         that no longer exist there (cards only; product pages stay browsable) */
      if (opts && opts.removeMissing && list && list.length) {
        var live = {};
        list.forEach(function (p) { if (p && p.id) live[p.id] = true; });
        $all("article.card[data-product]").forEach(function (card) {
          card.style.display = live[card.getAttribute("data-product")] ? "" : "none";
        });
      }
      resortGrid();
    };
    if (uiReady) run(); else pendingSync = run;
  }

  /* ------------------------------------------------------------------ */
  /* Wire up on DOM ready                                                */
  /* ------------------------------------------------------------------ */
  document.addEventListener("DOMContentLoaded", function () {

    drawer = $("#cart-drawer"); overlay = $("#cart-overlay"); fab = $("#cart-fab");
    if (drawer) drawer.inert = true; /* closed at load: unreachable to focus/AT */
    itemsEl = drawer ? $(".cart-items", drawer) : null;
    totalEl = drawer ? $("[data-cart-total]", drawer) : null;
    countEls = $all("[data-cart-count]");

    if (fab) fab.addEventListener("click", openCart);
    if (overlay) overlay.addEventListener("click", closeCart);
    if (drawer) {
      $all("[data-cart-close]", drawer).forEach(function (b) { b.addEventListener("click", closeCart); });
      var toCheckout = $("[data-to-checkout]", drawer);
      if (toCheckout) toCheckout.addEventListener("click", function () {
        if (!Object.keys(cart).length) { toast(T.needCart); return; }
        if (cartTotal() < MIN_ORDER) { toast(T.minOrder); return; }
        /* one checkout: Shopify's, with Ziina, card, COD and bank transfer */
        var parts = [];
        for (var id in cart) {
          var vid = PRODUCTS[id] && PRODUCTS[id].vid;
          if (!vid) { toast(T.onlineMissing); return; }
          parts.push(vid + ":" + cart[id]);
        }
        window.location.href = "https://olivo.ae/cart/" + parts.join(",");
      });
      var back = $("[data-to-cart]", drawer);
      if (back) back.addEventListener("click", function () { showView("cart"); });
      var send = $("[data-send-order]", drawer);
      if (send) send.addEventListener("click", function () {
        var f = readCheckoutForm();
        if (!validCheckout(f)) return;
        if (f.pay === "online") {
          if (!Object.keys(cart).length) { toast(T.needCart); return; }
          var parts = [];
          for (var id in cart) {
            var vid = PRODUCTS[id] && PRODUCTS[id].vid;
            if (!vid) { toast(T.onlineMissing); return; }
            parts.push(vid + ":" + cart[id]);
          }
          window.location.href = "https://olivo.ae/cart/" + parts.join(",");
          return;
        }
        openWA(composeOrder(f));
      });
      var copy = $("[data-copy-order]", drawer);
      if (copy) copy.addEventListener("click", function () {
        var f = readCheckoutForm();
        if (!validCheckout(f)) return;
        copyText(composeOrder(f), T.copyOk, T.copyFail);
      });
      $all('input[name="co-pay"]', drawer).forEach(function (r) {
        r.addEventListener("change", function () {
          drawer.classList.toggle("online-pay", r.value === "online");
          if (send) send.textContent = r.value === "online" ? T.confirmOnline : T.confirmWA;
        });
      });
      var ig = $("[data-send-ig]", drawer);
      if (ig) ig.addEventListener("click", function () {
        var f = readCheckoutForm();
        if (!validCheckout(f)) return;
        copyText(composeOrder(f), T.igCopied, T.copyFail);
        setTimeout(function () { window.open(IG_DM, "_blank", "noopener"); }, 400);
      });
    }
    document.addEventListener("keydown", function (e) {
      if (e.key === "Escape" && drawer && drawer.classList.contains("open")) closeCart();
    });

    /* product cards: availability + buttons -------------------------- */
    $all("[data-product]").forEach(wireCard);
    resortGrid();

    /* shop filter chips ------------------------------------------------ */
    var grid = $("[data-shop-grid]");
    if (grid) {
      $all("[data-filter]").forEach(function (chip) {
        chip.addEventListener("click", function () {
          $all("[data-filter]").forEach(function (c) { c.setAttribute("aria-pressed", "false"); });
          chip.setAttribute("aria-pressed", "true");
          var f = chip.getAttribute("data-filter");
          $all("[data-product]", grid).forEach(function (card) {
            var col = card.getAttribute("data-collection");
            card.style.display = (f === "all" || col === f) ? "" : "none";
          });
        });
      });
    }

    /* qty steppers on product pages ----------------------------------- */
    $all(".qty").forEach(function (q) {
      var input = $("input", q);
      if (!input || input.closest(".cart-item")) return;
      var btns = $all("button", q);
      if (btns[0]) btns[0].addEventListener("click", function () {
        input.value = Math.max(1, (parseInt(input.value, 10) || 1) - 1);
      });
      if (btns[1]) btns[1].addEventListener("click", function () {
        input.value = (parseInt(input.value, 10) || 1) + 1;
      });
    });

    /* gallery thumbs ---------------------------------------------------- */
    var main = $("[data-gallery-main]");
    if (main) {
      $all("[data-thumb]").forEach(function (t) {
        t.addEventListener("click", function () {
          $all("[data-thumb]").forEach(function (o) { o.setAttribute("aria-current", "false"); });
          t.setAttribute("aria-current", "true");
          var img = $("img", t);
          main.src = t.getAttribute("data-full");
          main.srcset = t.getAttribute("data-full-set") || "";
          main.alt = img ? img.alt : "";
        });
      });
    }

    /* gift quote form -> WhatsApp -------------------------------------- */
    var giftForm = $("#gift-form");
    if (giftForm) giftForm.addEventListener("submit", function (e) {
      e.preventDefault();
      var g = function (id) { var el = $(id); return el ? el.value.trim() : ""; };
      var lines = [T.giftIntro, ""];
      if (g("#gf-occasion")) lines.push(T.giftOccasion + ": " + g("#gf-occasion"));
      if (g("#gf-qty")) lines.push(T.giftQty + ": " + g("#gf-qty"));
      if (g("#gf-date")) lines.push(T.giftDate + ": " + g("#gf-date"));
      if (g("#gf-budget")) lines.push(T.giftBudget + ": " + g("#gf-budget") + " AED");
      if (g("#gf-note")) lines.push(T.orderNote + ": " + g("#gf-note"));
      lines.push(T.orderName + ": " + g("#gf-name"));
      openWA(lines.join("\n"));
    });

    /* contact form: simulated send, hands off to WhatsApp -------------- */
    var contactForm = $("#contact-form");
    if (contactForm) contactForm.addEventListener("submit", function (e) {
      e.preventDefault();
      var name = ($("#cf-name") || {}).value || "";
      var msg = ($("#cf-msg") || {}).value || "";
      toast(T.formSim);
      openWA(T.contactIntro + name.trim() + T.contactMsgIs + msg.trim());
    });

    /* mobile nav -------------------------------------------------------- */
    var navToggle = $(".nav-toggle"), nav = $(".main-nav");
    if (navToggle && nav) navToggle.addEventListener("click", function () {
      var open = nav.classList.toggle("open");
      navToggle.setAttribute("aria-expanded", open ? "true" : "false");
    });

    /* reveals ------------------------------------------------------------ */
    if ("IntersectionObserver" in window &&
        !window.matchMedia("(prefers-reduced-motion: reduce)").matches) {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (en) {
          if (en.isIntersecting) { en.target.classList.add("in"); io.unobserve(en.target); }
        });
      }, { threshold: 0.12, rootMargin: "0px 0px -4% 0px" });
      $all(".reveal").forEach(function (el) { io.observe(el); });
    } else {
      $all(".reveal").forEach(function (el) { el.classList.add("in"); });
    }

    renderCart();

    applyFees();
    uiReady = true;
    if (pendingSync) { pendingSync(); pendingSync = null; }
  });

  /* public surface: console debugging + the Shopify live-sync hook */
  window.OLIVO = { products: PRODUCTS, cart: cart, wa: waLink, applyShopify: applyShopify,
    applyDelivery: function (fees) {
      if (fees && fees.auh) FEES.auh = fees.auh;
      if (fees && fees.uae) FEES.uae = fees.uae;
      if (uiReady) applyFees();
    } };
})();
